import {
  apiRequest,
  listPeriodeTunsus,
  inactivePeriod,
  finishPeriod,
} from "../../../../../services/adapters/kepegawaian/revisiTunjanganKhususService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      listPeriodeTunsus,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  inactivePeriod = async (query) => {
    return await apiRequest(
      "post",
      inactivePeriod,
      {
        body: query,
      },
      true
    );
  };

  finishPeriod = async (query) => {
    return await apiRequest(
      "post",
      finishPeriod,
      {
        body: query,
      },
      true
    );
  };
}

export default DataTableRepository;
